(function () {
  var config = window.NOXTheme || {};
  var routes = config.routes || {};
  var customerId = config.customerId || "guest";
  var wishlistKey = "nox_wishlist_" + customerId;
  var wishlistDataKey = wishlistKey + "_data";

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function money(cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey)) || [];
    } catch (error) {
      return [];
    }
  }

  function setWishlist(handles) {
    localStorage.setItem(wishlistKey, JSON.stringify(handles));
    updateWishlistUI();
  }

  function getWishlistData() {
    try {
      return JSON.parse(localStorage.getItem(wishlistDataKey)) || {};
    } catch (error) {
      return {};
    }
  }

  function setWishlistData(data) {
    localStorage.setItem(wishlistDataKey, JSON.stringify(data));
  }

  function updateWishlistUI() {
    var handles = getWishlist();
    qsa("[data-wishlist-button]").forEach(function (button) {
      button.classList.toggle("is-active", handles.indexOf(button.dataset.productHandle) !== -1);
    });
    qsa("[data-wishlist-count]").forEach(function (node) {
      node.textContent = handles.length;
    });
  }

  function initWishlist() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-wishlist-button]");
      if (!button) return;
      event.preventDefault();

      var handle = button.dataset.productHandle;
      var handles = getWishlist();
      var data = getWishlistData();
      var index = handles.indexOf(handle);

      if (index === -1) {
        handles.push(handle);
        data[handle] = {
          title: button.dataset.productTitle,
          url: button.dataset.productUrl
        };
      } else {
        handles.splice(index, 1);
        delete data[handle];
      }

      setWishlistData(data);
      setWishlist(handles);
      renderWishlistPage();
    });

    updateWishlistUI();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    var container = qs("[data-wishlist-grid]");
    if (!container) return;
    var handles = getWishlist();
    var data = getWishlistData();
    container.innerHTML = "";

    handles.forEach(function (handle) {
      var item = data[handle] || { title: handle, url: "/products/" + handle };
      var article = document.createElement("article");
      article.className = "product-card";
      article.innerHTML =
        '<div class="product-card__body">' +
        '<div class="product-card__topline"><span>Wishlist</span></div>' +
        '<h3 class="product-card__title"><a href="' + item.url + '">' + item.title + '</a></h3>' +
        '<div class="product-card__meta">Saved for this customer login on this browser.</div>' +
        '<div class="product-card__footer"><a class="button" href="' + item.url + '">View product</a></div>' +
        "</div>";
      container.appendChild(article);
    });
  }

  function openCartDrawer() {
    var drawer = qs("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeCartDrawer() {
    var drawer = qs("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function renderCart(cart) {
    qsa("[data-cart-count]").forEach(function (node) {
      node.textContent = cart.item_count;
    });

    var itemsContainer = qs("[data-cart-items]");
    var totalContainer = qs("[data-cart-total]");
    var emptyContainer = qs("[data-cart-empty]");
    if (!itemsContainer || !totalContainer) return;

    totalContainer.textContent = money(cart.total_price);
    itemsContainer.innerHTML = "";
    if (emptyContainer) emptyContainer.hidden = cart.item_count > 0;

    cart.items.forEach(function (item, index) {
      var row = document.createElement("div");
      row.className = "cart-item";
      row.innerHTML =
        '<a href="' + item.url + '">' +
        (item.image ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g, "&quot;") + '">' : "") +
        '</a><div><a class="cart-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
        (item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : "") +
        '<div class="cart-item__variant">' + money(item.final_line_price) + '</div>' +
        '<div class="cart-item__actions" data-line="' + (index + 1) + '" style="display: flex; align-items: center; gap: 15px; margin-top: 10px;">' +
        '<div class="quantity">' +
        '<button type="button" data-cart-qty="' + (item.quantity - 1) + '">-</button>' +
        '<input value="' + item.quantity + '" inputmode="numeric" aria-label="Quantity" readonly>' +
        '<button type="button" data-cart-qty="' + (item.quantity + 1) + '">+</button>' +
        '</div>' +
        '<button type="button" class="cart-item__remove" data-cart-qty="0" aria-label="Eliminar" style="background: transparent; border: none; cursor: pointer; color: #777; padding: 5px; display: flex; align-items: center; justify-content: center;" onmouseover="this.style.color=\'#cc0000\'" onmouseout="this.style.color=\'#777\'">' +
        '<svg viewBox="0 0 16 16" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2.5 3.5h11M6 3.5v-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1M4 3.5v9.5A1.5 1.5 0 0 0 5.5 14.5h5a1.5 1.5 0 0 0 1.5-1.5v-9.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '</div></div>';
      itemsContainer.appendChild(row);
    });
  }

  function refreshCart(openDrawer) {
    return fetch((routes.cart_url || "/cart") + ".js", { credentials: "same-origin" })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (openDrawer) openCartDrawer();
        return cart;
      });
  }

  function initCart() {
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-cart-open]")) {
        event.preventDefault();
        refreshCart(true);
      }
      if (event.target.closest("[data-cart-close]")) {
        event.preventDefault();
        closeCartDrawer();
      }

      var qtyButton = event.target.closest("[data-cart-qty]");
      if (qtyButton) {
        var quantity = Number(qtyButton.dataset.cartQty);
        var line = Number(qtyButton.closest("[data-line]").dataset.line);
        fetch((routes.cart_change_url || "/cart/change") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ line: line, quantity: Math.max(quantity, 0) })
        }).then(function (response) { return response.json(); }).then(function (cart) {
          renderCart(cart);
        });
      }
    });

    document.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-ajax-cart-form]");
      if (!form) return;
      event.preventDefault();
      var submit = qs("button[type='submit']", form);
      if (submit) submit.disabled = true;

      fetch((routes.cart_add_url || "/cart/add") + ".js", {
        method: "POST",
        credentials: "same-origin",
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart add failed");
          return response.json();
        })
        .then(function () { return refreshCart(true); })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function initMobileMenu() {
    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-mobile-menu-toggle]");
      if (!toggle) return;
      var panel = qs("[data-mobile-panel]");
      if (!panel) return;
      var isOpen = panel.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  function initVehicleFinder() {
    qsa("[data-vehicle-finder]").forEach(function (form) {
      var make = qs("[data-finder-make]", form);
      var model = qs("[data-finder-model]", form);
      if (!make || !model) return;

      var KNOWN_BRANDS = ['AUDI','BMW','CADILLAC','CHEVROLET','DODGE','FORD',
            'HONDA','HYUNDAI','ISUZU','JEEP','KIA','LAND ROVER','LEXUS','MASERATI',
            'MAZDA','MERCEDES BENZ','MERCEDES','MITSUBISHI','NISSAN','PORSCHE','TOYOTA'];

      function isBrand(t){ return KNOWN_BRANDS.indexOf(t.trim().toUpperCase()) !== -1; }

      make.addEventListener("change", function() {
        var brand = make.value;
        model.innerHTML = '<option value="">Cargando modelos...</option>';
        model.disabled = true;

        if (!brand) {
          model.innerHTML = '<option value="">Selecciona Modelo</option>';
          model.disabled = false;
          return;
        }

        var results = {};
        var search  = brand.trim().toUpperCase();
        var pg      = 1;

        function fetchNextPage(){
          fetch('/collections/all/products.json?limit=250&page=' + pg)
            .then(function(r){ return r.json(); })
            .then(function(data){
              var list = data.products || [];

              for (var i = 0; i < list.length; i++){
                var p = list[i];
                var rawTags = p.tags || '';
                var tags = Array.isArray(rawTags) 
                  ? rawTags 
                  : String(rawTags).split(',').map(function(t){ return t.trim(); }).filter(Boolean);

                var pBrands = tags.filter(isBrand);
                
                // Mismo filtro estricto: solo aprender modelos de productos que tengan EXACTAMENTE esta marca
                if (pBrands.length === 1 && pBrands[0].toUpperCase() === search){
                  tags.forEach(function(t){
                    if (!isBrand(t)) results[t] = true;
                  });
                }
              }

              if (list.length === 250){ 
                pg++; 
                fetchNextPage(); 
              } else {
                var sorted = Object.keys(results).sort(function(a,b){ return a.localeCompare(b); });
                model.innerHTML = '<option value="">Selecciona Modelo</option>';
                sorted.forEach(function(m){
                  var opt = document.createElement("option");
                  opt.value = m;
                  opt.textContent = m;
                  model.appendChild(opt);
                });
                model.disabled = false;
              }
            })
            .catch(function(){
              model.innerHTML = '<option value="">Selecciona Modelo</option>';
              model.disabled = false;
            });
        }
        fetchNextPage();
      });

      function handleize(str){
        return str.toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      }

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        
        var tags = [];
        if (make.value) tags.push(make.value);
        if (model.value) tags.push(model.value);
        
        var url = '/collections/all';
        if (tags.length > 0) {
          url += '/' + tags.map(handleize).join('+');
        }
        
        window.location.href = url;
      });
    });
  }

  function initSort() {
    qsa("[data-sort-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", select.value);
        window.location.href = url.toString();
      });
    });
  }

  function initProductGallery() {
    function setActiveMedia(mediaId) {
      if (!mediaId) return;
      var mediaItems = qsa('.product-gallery__media-item');
      if (mediaItems.length === 0) return;
      mediaItems.forEach(function(el) {
        if (el.getAttribute('data-media-id') === mediaId) {
          el.style.display = 'block';
          el.classList.add('is-active');
        } else {
          el.style.display = 'none';
          el.classList.remove('is-active');
        }
      });
    }

    document.addEventListener("click", function(event) {
      var thumbnail = event.target.closest(".product-gallery__thumbnail");
      if (thumbnail) {
        var mediaId = thumbnail.getAttribute("data-media-id");
        setActiveMedia(mediaId);
        
        qsa(".product-gallery__thumbnail").forEach(function(el) {
          el.classList.remove("is-active");
        });
        thumbnail.classList.add("is-active");
      }
    });

    document.addEventListener("change", function(event) {
      var select = event.target.closest(".variant-selects select");
      if (select) {
        var option = select.options[select.selectedIndex];
        var variantMediaId = option.getAttribute("data-variant-media-id");
        if (variantMediaId) {
          setActiveMedia(variantMediaId);
        } else {
          // Fallback to old image swapping if no media id
          var mainImage = document.querySelector('.product-gallery__media-item.is-active img');
          var variantImageUrl = option.getAttribute("data-variant-image");
          if (variantImageUrl && mainImage) {
            mainImage.removeAttribute("srcset");
            mainImage.removeAttribute("sizes");
            mainImage.src = variantImageUrl;
          }
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.documentElement.classList.remove("no-js");
    initMobileMenu();
    initCart();
    initWishlist();
    initVehicleFinder();
    initSort();
    initProductGallery();
    refreshCart(false);
  });
})();
